import { useSetRecoilState } from "recoil";
import { post } from "../..";
import { ACCOUNT_TYPE, authState } from "recoil/auth";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";

const useAuthActions = () => {
  const [searchParams] = useSearchParams();
  const setAuth = useSetRecoilState(authState);
  /**
   *
   * @param {Object} params
   * @param {string} params.id
   * @param {string} params.password
   *
   * @returns {Promise}
   */

  async function adminLogin(params) {
    const res = await post("login/admin", {
      ...params,
      type: ACCOUNT_TYPE.ADMIN,
    });

    // console.log("params", params);
    // console.log("res", res);
    if (!params?.id) {
      alert("아이디를 입력 해 주세요.");
      throw Error("아이디를 입력 해 주세요.");
    }
    if (!params?.pw) {
      alert("비밀번호를 입력 해 주세요.");
      throw Error("비밀번호를 입력 해 주세요.");
    }
    if (res?.status !== 200) {
      alert("로그인 정보가 일치하지 않습니다.");
      throw Error("로그인 정보가 일치하지 않습니다.");
    }

    if (res?.data) {
      const payload = jwtDecode(res.data.accesstoken);
      res.token = res.data;
      res.user = { ...payload, type: ACCOUNT_TYPE.ADMIN, type_string: "admin" };

      Cookies.set("refreshToken", res.token.refreshtoken);

      localStorage.setItem("expiresAt", payload.exp);
      localStorage.setItem("accessToken", res.token.accesstoken);
      localStorage.setItem("authInfo", JSON.stringify(res));
      setAuth(res);
    }
    return res;
  }

  /**
   *
   * @param {Object} params
   * @param {string} params.id
   * @param {string} params.password
   *
   * @returns {Promise}
   */
  async function raterLogin(params) {
    const res = await post("login/rater", {
      ...params,
      type: ACCOUNT_TYPE.RATER,
    });

    // console.log("params", params);
    // console.log("res", res);
    if (!params?.id) {
      alert("아이디를 입력 해 주세요.");
      throw Error("아이디를 입력 해 주세요.");
    }
    if (!params?.pw) {
      alert("비밀번호를 입력 해 주세요.");
      throw Error("비밀번호를 입력 해 주세요.");
    }
    if (res?.status !== 200) {
      alert("로그인 정보가 일치하지 않습니다.");
      throw Error("로그인 정보가 일치하지 않습니다.");
    }

    if (res?.data) {
      const payload = jwtDecode(res.data.accesstoken);
      res.token = res.data;
      res.user = { ...payload, type: ACCOUNT_TYPE.RATER, type_string: "rater" };

      Cookies.set("refreshToken", res.token.refreshtoken);

      localStorage.setItem("expiresAt", payload.exp);
      localStorage.setItem("accessToken", res.token.accesstoken);
      localStorage.setItem("authInfo", JSON.stringify(res));
      setAuth(res);
    }

    return res;
  }

  /**
   *
   * @param {Object} params
   * @param {number} params.id
   * @param {string} params.name
   *
   * @returns {Promise}
   */
  async function applyLogin(params) {
    const res = await post(
      "login/tester",
      {
        ...params,
      },
      { OS: window.navigator.userAgent }
    );

    if (!params?.name) throw Error("이름을 입력 해 주세요.");

    if (!params?.code) throw Error("평가응시코드를 입력 해 주세요.");

    // if (res?.status !== 200) throw Error(res?.data?.text);
    if (res?.status !== 200) throw Error("입력하신 정보가 일치하지 않습니다.");

    if (res?.data) {
      const payload = jwtDecode(res.data.accesstoken);
      res.token = res.data;
      res.user = { ...payload, type: ACCOUNT_TYPE.APPLICANT };

      localStorage.setItem("expiresAt", payload.exp);
      localStorage.setItem("accessToken", res.token.accesstoken);
      localStorage.setItem("authInfo", JSON.stringify(res));
      setAuth(res);
    }

    return res;
  }

  async function logout() {
    localStorage.removeItem("authInfo");
    setAuth(null);
    window.location.reload();
  }

  /**
 *
 * @param {Object} params
 * @param {string} uid
 *
 * @returns {Promise}
 */

async function applyPass(params) {
  const res = await post(
    "login/passter",
    {
      ...params,
    },
    { OS: window.navigator.userAgent }
  );

  if (res?.status !== 200) throw Error("응시자 정보를 찾을 수 없습니다.");

  if (res?.data) {
    const payload = jwtDecode(res.data.accesstoken);
    res.token = res.data;
    res.user = { ...payload, type: ACCOUNT_TYPE.APPLICANT };

    localStorage.setItem("expiresAt", payload.exp);
    localStorage.setItem("accessToken", res.token.accesstoken);
    localStorage.setItem("authInfo", JSON.stringify(res));

    setAuth(res);
  }

  return res;
}

  return { adminLogin, applyLogin, applyPass, raterLogin, logout };
};



async function applyTest(params) {
  const res = await post("login");
}

export default useAuthActions;
